import { RiskRanges } from "../ranges";
import { Risk, Unit, Value } from "../units";

function rangesFor() {
  return new RiskRanges("mg/L", [
    { from: 3, to: 4, risk: Risk.HighRisk, label: "high" },
    { from: 2, to: 3, risk: Risk.Risk, label: "moderate" },
    { from: 1, to: 2, risk: Risk.Normal, label: "mild" },
    { from: 0.5, to: 1, risk: Risk.Optimal, label: "optimal" },
  ]);
}

export const CRP = {
  rangesFor,
};
